// don't convert to TS yet as startup code can't understand it.

export const EventTrackingConstants = {
  UNIVERSAL_COMPOSER_CLASSES: 'universal_composer_classes',

  // tracking sms links to public messages
  TEXT_MESSAGE: 'text_message',
  REACTION_LINK: 'reaction_link',
  ATTACHMENT_LINK: 'attachment_link',

  // platforms
  ANDROID_MOBILE_WEB: 'android_mobile_web',
  IOS_MOBILE_WEB: 'ios_mobile_web',
  OTHER_MOBILE_WEB: 'other_mobile_web',
  DESKTOP_WEB: 'desktop_web',
  OTHER_WEB: 'other_web',
};
